import * as fromRoot from '../../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CuttingTableActions, CuttingTableActitonTypes } from './cutting_table.actions';
import { User } from '../../../_models/user';
import { CuttingTable } from '../../../_models/cutting_table';
import { CuttingTableType } from '../../../_models/cutting_table_type';

export interface State extends fromRoot.State {
	cutting_tables: CuttingTableState;
}

export interface CuttingTableState {
  currentCuttingTableId: bigint | null;
  currentCuttingTable: CuttingTable;
	cutting_tableList: CuttingTable[];
	cutting_tableTypeList: CuttingTableType[];
	userList: User[];

	filterFields: any;

	error: string;
}

const initialItem: CuttingTable = {
  id: null,
  name: '',
  type_id: null,
  desc: null,
	path: null,
	enviroment: null,
	param1: null,
	param2: null,
	param3: null,
	param4: null,
  sheet_load_unload_min: null,
  cut_speed_mm_s: null,
  disband_l: null,
  disband_b: null,
  disband_r: null,
  disband_t: null,
  order: 0,
  active: false,
};

const initialState: CuttingTableState = {
  currentCuttingTableId: null,
  currentCuttingTable: initialItem,
	cutting_tableList: [],
  cutting_tableTypeList: [],
	userList: [],
	filterFields: [],
	error: ''
};

const getCuttingTableFeatureState = createFeatureSelector<CuttingTableState>('cutting_tables');

export const getCurrentCuttingTableId = createSelector(
	getCuttingTableFeatureState,
	state => state.currentCuttingTableId
);

export const getCurrentCuttingTable = createSelector(
    getCuttingTableFeatureState,
    getCurrentCuttingTableId,
    (state, currentCuttingTableId) => {
        if (currentCuttingTableId == null) {
            return initialItem;
        } else {
            return currentCuttingTableId ? state.cutting_tableList.find(p => p.id === currentCuttingTableId) : null;
        }
    }
);

export const getCuttingTableList = createSelector(
	getCuttingTableFeatureState,
	state => state.cutting_tableList
);

export const getCuttingTableTypesList = createSelector(
	getCuttingTableFeatureState,
	state => state.cutting_tableTypeList
);

export const getUserList = createSelector(
	getCuttingTableFeatureState,
	state => state.userList
);

export const getFilterFields = createSelector(
	getCuttingTableFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getCuttingTableFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: CuttingTableActions): CuttingTableState {

	// console.log('--> CuttingTable Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action CuttingTable type: ');
	// console.log(action.type);

	switch (action.type) {

		case CuttingTableActitonTypes.SetCurrentCuttingTable:

			console.log('--> Entando en acción SetCurrentCuttingTable.');

			if (action.payload !== null) {

				return {
					...state,
					currentCuttingTableId: action.payload.id,
					currentCuttingTable: action.payload
				};
			} else {
				return {
					...state,
					currentCuttingTableId: null,
					currentCuttingTable: initialItem
				};
			}

		case CuttingTableActitonTypes.SetCurrentCuttingTableId:

			console.log('--> Entando en acción SetCurrentCuttingTable.');

			return {
                ...state,
				currentCuttingTableId: action.payload
			};

		case CuttingTableActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

        case CuttingTableActitonTypes.GetCurrentCuttingTable:

			console.log('--> Entando en acción GetCurrentCuttingTable.');

			return state;

		case CuttingTableActitonTypes.ClearCuttingTable:

			console.log('--> Entando en acción ClearCuttingTable.');

			return {
					...state,
					currentCuttingTableId: null
				};


		case CuttingTableActitonTypes.InicializeCuttingTable:

			console.log('--> Entando en acción InicializeCuttingTable.');

			state = initialState;

			return state;


		case CuttingTableActitonTypes.LoadCuttingTablesSuccess:

			console.log('--> Entando en acción LoadCuttingTablesSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					cutting_tableList: action.payload,
					error: ''
				};

		case CuttingTableActitonTypes.LoadCuttingTablesFail:

			console.log('--> Entando en acción LoadCuttingTablesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					cutting_tableList: [],
					error: action.payload
				};

    case CuttingTableActitonTypes.LoadCuttingTableTypesSuccess:

			console.log('--> Entando en acción LoadCuttingTableTypesSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					cutting_tableTypeList: action.payload,
					error: ''
				};

		case CuttingTableActitonTypes.LoadCuttingTableTypesFail:

			console.log('--> Entando en acción LoadCuttingTableTypesFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					cutting_tableTypeList: [],
					error: action.payload
				};

		// case CuttingTableActitonTypes.UpdateCuttingTable:

		// 	console.log('--> Entando en acción UpdateCuttingTable.');

		// 	// state = initialState;

		// 	return state;

		case CuttingTableActitonTypes.UpdateCuttingTableSuccess:

			console.log('--> Entando en acción UpdateCuttingTableSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxCuttingTableList = [];

			if (action.payload !== undefined) {
				console.log(' -> El proyecto a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxCuttingTableList = state.cutting_tableList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						cutting_tableList: auxCuttingTableList,
						currentCuttingTableId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La obra a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar la obra.'
				};
			}

		case CuttingTableActitonTypes.UpdateCuttingTableFail:

			console.log('--> Entrando en acción UpdateCuttingTableFail.');

			return {
					...state,
					error: action.payload
				};

		case CuttingTableActitonTypes.CreateCuttingTableSuccess:

			console.log('--> Entrando en acción CreateCuttingTableSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentCuttingTables = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.cutting_tableList.push(action.payload);

					return {
						...state,
						cutting_tableList: state.cutting_tableList,
						currentCuttingTableId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentCuttingTableId: null,
					error: 'No se ha podido crear la obra.'
				};
			}

		case CuttingTableActitonTypes.CreateCuttingTableFail:

			console.log('--> Entrando en acción CreateCuttingTableFail.');

			return {
					...state,
					currentCuttingTableId: null,
					error: action.payload
				};

		case CuttingTableActitonTypes.DeleteCuttingTableSuccess:

			console.log('--> Entrando en acción DeleteCuttingTableSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha creado.
			// this.currentCuttingTables = null;

			if (action.payload !== undefined) {
				console.log(' -> El proyecto borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.cutting_tableList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de obras:');
					console.log(filterList);

					return {
						...state,
						cutting_tableList: filterList,
						currentCuttingTableId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El proyecto a crear está vacío.');

				return {
					...state,
					currentCuttingTableId: null,
					error: 'No se ha podido crear la obra.'
				};
			}

		case CuttingTableActitonTypes.DeleteCuttingTableFail:

			console.log('--> Entrando en acción DeleteCuttingTableSuccess.');

			return {
					...state,
					currentCuttingTableId: null,
					error: action.payload
				};

		case CuttingTableActitonTypes.LoadUsersSuccess:

			console.log('--> Entando en acción LoadUsersSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					userList: action.payload,
					error: ''
				};

		case CuttingTableActitonTypes.LoadUsersFail:

			console.log('--> Entando en acción LoadUsersFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userList: [],
					error: action.payload
				};

		default:
			return state;
	}
}
